// extracted by mini-css-extract-plugin
export default {"header":"FailClose_header__K7xka","description":"FailClose_description__GATen","empty":"FailClose_empty__b-LBH","warningText":"FailClose_warningText__a56Ft"};